import React from 'react';
import {TopAppBar, TopAppBarSection, TopAppBarRow, TopAppBarFixedAdjust, TopAppBarTitle, TopAppBarNavigationIcon} from '@rmwc/top-app-bar';
import {Drawer, DrawerHeader, DrawerTitle, DrawerSubtitle, DrawerContent} from '@rmwc/drawer';
import {Button} from '@rmwc/button'
import {List, ListItem} from '@rmwc/list';
import { APP_NAME, APP_TAGLINE } from '../Configs/appConfig';
import * as routes from '../Configs/routes';
import {Link, withRouter, matchPath} from 'react-router-dom';
import firebase from './firebase/firebase';
import { connect } from 'react-redux';

function mapStateToProps(state){
    return {
        user: state.user.user
    }
}

class Header extends React.Component {
    state = {
        sideNavOpen: false
    }
    toggleSideNav(open){
        this.setState(prev=>({
            ...prev,
            sideNavOpen: open
        }))
    }
    render(){
        return (
            <React.Fragment>
                <Drawer style modal open={this.state.sideNavOpen} onClose={() => this.toggleSideNav(false)}>
                    <DrawerHeader>
                        <Link to={routes.HOME} className="link-unstyled">  
                            <div className="w-100 d-flex justify-content-center align-items-center p-2">
                                <img 
                                    src={window.location.origin+'/logo192.webp'}
                                    className='img-fluid rounded-circle'
                                    alt={APP_NAME}
                                />
                            </div>                          
                            <DrawerTitle>
                                {APP_NAME}
                            </DrawerTitle>
                        </Link>
                    <DrawerSubtitle>{APP_TAGLINE}</DrawerSubtitle>
                    </DrawerHeader>
                    <DrawerContent>
                    <List>
                        <Link to={routes.HOME} key={routes.HOME} className="link-unstyled">
                            <ListItem activated={matchPath(this.props.match.path,{
                                path: routes.HOME,
                                exact: true
                            })}>
                                HOME
                            </ListItem>
                        </Link>
                        <Link to={routes.TOURNAMENTS} key={routes.TOURNAMENTS} className="link-unstyled">
                            <ListItem activated={matchPath(this.props.match.path,{
                                path: routes.TOURNAMENTS,
                                exact: true
                            })}>
                                Tournaments
                            </ListItem>
                        </Link>
                        <Link to={routes.ADMIN} key={routes.ADMIN} className="link-unstyled">
                            <ListItem activated={matchPath(this.props.match.path,{
                                path: routes.ADMIN,
                                exact: true
                            })}>
                                Admin Panel
                            </ListItem>
                        </Link>
                        { 
                            this.props.user && this.props.user.superadmin &&
                            <Link to={routes.MANAGE_ADMINS} key={routes.MANAGE_ADMINS} className="link-unstyled">
                                <ListItem activated={matchPath(this.props.match.path,{
                                    path: routes.MANAGE_ADMINS,
                                    exact: true
                                })}>
                                    Manage Admins
                                </ListItem>
                            </Link>
                        }
                        { 
                            this.props.user &&
                                <div className="d-flex justify-content-center p-3" style={{width: "100%"}}>
                                    <Button onClick={()=> firebase.auth().signOut()} outlined>Log out</Button>
                                </div>
                        }
                    </List>
                    </DrawerContent>
                </Drawer>
                <TopAppBar onNav={()=>this.toggleSideNav(true)}>
                    <TopAppBarRow> 
                        <TopAppBarSection alignStart>
                            <Link to={routes.HOME} className="link-unstyled text-white">
                                <TopAppBarTitle>                                
                                    <img 
                                        src={window.location.origin+'/logo.webp'}
                                        className='img-fluid'
                                        style={{maxWidth: "2rem"}}
                                        alt={APP_NAME}
                                    />
                                    {APP_NAME}
                                </TopAppBarTitle>
                            </Link>
                        </TopAppBarSection>
                        <TopAppBarSection alignEnd>
                            <TopAppBarNavigationIcon icon="menu" />
                        </TopAppBarSection>
                    </TopAppBarRow>
                    </TopAppBar>
                <TopAppBarFixedAdjust />  
                
            </React.Fragment>      
        );
    }
}
export default withRouter(connect(mapStateToProps)(Header));